import axios from '../../config/axios';

export const couponsApi = {
    // التحقق من صلاحية الكوبون
    validateCoupon: async (code, cartItems) => {
        try {
            const response = await axios.post('/api/coupons/validate', {
                code,
                items: cartItems
            });
            return response.data;
        } catch (error) {
            console.error('Validate coupon error:', error);
            throw error;
        }
    },

    // الحصول على كل الكوبونات (للإدارة فقط)
    getAllCoupons: async () => {
        try {
            const response = await axios.get('/api/admin/coupons');
            return response.data;
        } catch (error) {
            console.error('Get all coupons error:', error);
            throw error;
        }
    },

    // إضافة كوبون جديد
    addCoupon: async (couponData) => {
        try {
            const response = await axios.post('/api/admin/coupons', couponData);
            return response.data;
        } catch (error) {
            console.error('Add coupon error:', error);
            throw error;
        }
    },

    // تحديث كوبون
    updateCoupon: async (id, couponData) => {
        try {
            const response = await axios.put(`/api/admin/coupons/${id}`, couponData);
            return response.data;
        } catch (error) {
            console.error('Update coupon error:', error);
            throw error;
        }
    },

    // حذف كوبون
    deleteCoupon: async (id) => {
        try {
            const response = await axios.delete(`/api/admin/coupons/${id}`);
            return response.data;
        } catch (error) {
            console.error('Delete coupon error:', error);
            throw error;
        }
    }
};
